import moment from "moment-timezone";
import { getRecoil } from "recoil-nexus";
import { masterStoreState, qrAuthState } from "../recoil/auth";
import Axios, { Response } from "../utils/Axios";

type Params =
  | "timer"
  | "sector"
  | "category"
  | "product"
  | "card"
  | "voucher"
  | "coupon"
  | "adver"
  | "concierge"
  | "storeChat"
  | "cs"
  | "cart"
  | "event"
  | "navigate"
  | "payment"
  | "order"
  | "morningCall"
  | "arrival"
  | "checkout"
  | "cancel"
  | "rating"
  | "lang"
  | "click"
  | "guide"
  | "error";

// click: {
//     path: 로그 발생지 (페이지),
//     params: 목적(이벤트 클릭, 상품 담기 등),
//     params2: 코멘트(매장 이름, 이벤트 이름 등),
//     store_id?: 타겟 매장 id (있을 때만)
//     index?: 타겟 id(sector_id, product_id, event_id...)
// }

// navigate: {
//     path: 로그 발생지 (페이지),
//     params: 발생 이벤트 (페이지 이동, 광고 이동 등),
//     params2: 코멘트(매장 이름, 이벤트 이름 등),
//     store_id?: 타겟 매장 id (있을 때만)
//     index?: 타겟 id(sector_id, product_id...)
// }

// event: {
//     path: 로그 발생지 (페이지),
//     params: 발생한 이벤트(채팅, 도착, 취소, 평가, ...),
//     params2: 코멘트(매장 이름, 이벤트 이름 등),
//     store_id?: 타겟 매장 id (있을 때만)
//     index?: 타겟 id(order_id, cs_id...),
// }

const LogController = {
  click: async (data: {
    path: string;
    params: Params;
    params2: string;
    store_id?: number;
    index?: number;
  }): Promise<Response> => {
    try {
      const oParams = {
        user_token_id: getRecoil(qrAuthState).user_token_id,
        user_id: getRecoil(qrAuthState).user_id,
        parent_store_id: getRecoil(masterStoreState).store_id,
        action_name: "qr_click",
      };

      let sUrl = process.env.REACT_APP_API_URL + "/log/path";

      const response: any = await Axios.post(sUrl, {
        ...oParams,
        ...data,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      return response.data;
    } catch (err: any) {
      console.error("ERROR [log/path] : ", err);

      return {
        ok: false,
        msg: "ERROR [log/path] : " + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  navigate: async (data: {
    path: string;
    params: Params;
    params2: string;
    store_id?: number;
    index?: number;
  }): Promise<Response> => {
    try {
      const oParams = {
        user_token_id: getRecoil(qrAuthState).user_token_id,
        user_id: getRecoil(qrAuthState).user_id,
        parent_store_id: getRecoil(masterStoreState).store_id,
        action_name: "qr_navigate",
      };

      let sUrl = process.env.REACT_APP_API_URL + "/log/path";

      const response: any = await Axios.post(sUrl, {
        ...oParams,
        ...data,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      return response.data;
    } catch (err: any) {
      console.error("ERROR [log/path] : ", err);

      return {
        ok: false,
        msg: "ERROR [log/path] : " + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  event: async (data: {
    path: string;
    params: string;
    params2: string;
    store_id?: number;
    index?: number;
  }): Promise<Response> => {
    try {
      const oParams = {
        user_token_id: getRecoil(qrAuthState).user_token_id,
        user_id: getRecoil(qrAuthState).user_id,
        parent_store_id: getRecoil(masterStoreState).store_id,
        action_name: "qr_event",
      };

      let sUrl = process.env.REACT_APP_API_URL + "/log/path";

      const response: any = await Axios.post(sUrl, {
        ...oParams,
        ...data,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      return response.data;
    } catch (err: any) {
      console.error("ERROR [log/path] : ", err);

      return {
        ok: false,
        msg: "ERROR [log/path] : " + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
  api: async (data: {
    path: string;
    params: Params;
    params2: string;
    store_id?: number;
    index?: number;
  }): Promise<Response> => {
    try {
      const oParams = {
        user_token_id: getRecoil(qrAuthState).user_token_id,
        user_id: getRecoil(qrAuthState).user_id,
        parent_store_id: getRecoil(masterStoreState).store_id,
        action_name: "qr_api",
      };

      let sUrl = process.env.REACT_APP_API_URL + "/log/path";

      const response: any = await Axios.post(sUrl, {
        ...oParams,
        ...data,
        created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      });

      return response.data;
    } catch (err: any) {
      console.error("ERROR [log/path] : ", err);

      return {
        ok: false,
        msg: "ERROR [log/path] : " + err.toString(),
        data: undefined,
        status: 500,
      };
    }
  },
};

export default LogController;
